import styled from 'styled-components';
import { TypographyStyles, anchorTagHoverAnimation, colours, media, spacing } from '../../../../stylings';

export const NavLinkItemHeader = styled.h2`
  margin: 0;
  ${TypographyStyles.Body.Small.SemiBold}
  white-space: normal;
`;

export const NavigationListItemContainer = styled.li`
  /* stylelint-disable selector-type-no-unknown */
  ${() =>
    anchorTagHoverAnimation({
      backgroundColor: colours.BLACK,
    })}
`;

export const ProductTypeList = styled.ul`
  padding: ${spacing.S} 0 0;
  > li {
    margin-bottom: ${spacing.XXS};

    > a {
      ${TypographyStyles.Body.Tiny.Regular}
      white-space: normal;

      @media ${media.greaterThan('lg')} {
        font-size: 14px;
      }
    }
  }
`;
